import React from 'react';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Switch from '../../../../shared/switch';
import Table from '../../../../shared/table';

const tableColumns = ['Name', 'Email', 'Username', 'Enabled', 'Actions']

interface ISuppliersTable {
    rows: any;
    paginationData?: IPage;
    accessControl?: any;
    actions?: any;
    rowsLoading: boolean;
    onSeeSupplierDetails: (id: string) => void;
    onEditSupplier: (partnerId: string) => void;
    onEnableDisableSupplier: (id: string, currentStatus: boolean) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onDeleteSupplierRequest: (id: string) => void;

}

const SuppliersTable = ({
    rows,
    paginationData,
    accessControl,
    actions,
    rowsLoading,
    onEditSupplier,
    setPaginationState,
    onDeleteSupplierRequest,
    onEnableDisableSupplier,
    onSeeSupplierDetails
}: ISuppliersTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.name}</td>
                                <td className='px-6 py-4'>{row?.email}</td>
                                <td className='px-6 py-4'>{row?.username}</td>
                                <td className='px-6 py-4'>
                                    <Switch
                                        checked={!!row?.enabled}
                                        onToggleSwitch={() => ((!accessControl || actions?.['Supplier Enable Disable']) && row?._id) && onEnableDisableSupplier(row?._id, row?.enabled || false)}
                                    />
                                </td>
                                <td className='px-6 py-4 min-w-[120px]'>
                                    <div className='flex flex-row'>
                                        <div data-qa='supplier-details' onClick={() => ((!accessControl || actions?.['Supplier Details']) && row?._id) && onSeeSupplierDetails(row?._id)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={`h-[14px] object-contain ${(!accessControl || actions?.['Supplier Details']) ? 'cursor-pointer' : 'cursor-not-allowed'} mr-2`} />
                                        </div>
                                        <div data-qa='supplier-edit' onClick={() => ((!accessControl || actions?.['Supplier Edit']) && row?._id) && onEditSupplier(row?._id)}>
                                            <img title={'Edit Supplier'} alt='edit supplier' src={'/assets/table-actions/pen.svg'} className={`h-[14px] object-contain ${(!accessControl || actions?.['Supplier Edit']) ? 'cursor-pointer' : 'cursor-not-allowed'} mr-2`} />
                                        </div>
                                        <div data-qa='supplier-delete' onClick={() => ((!accessControl || actions?.['Supplier Delete']) && row?._id) && onDeleteSupplierRequest(row?._id)}>
                                            <img title={'Delete Supplier'} alt='delete supplier' src={'/assets/table-actions/delete-close.svg'} className={`h-[14px] object-contain ${(!accessControl || actions?.['Supplier Delete']) ? 'cursor-pointer' : 'cursor-not-allowed'} mr-2`} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default SuppliersTable;